// eslint-disable-next-line import/no-extraneous-dependencies
import { initializeApp } from 'firebase/app';
// eslint-disable-next-line import/no-extraneous-dependencies
import { getAuth } from 'firebase/auth';
// eslint-disable-next-line import/no-extraneous-dependencies
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
// eslint-disable-next-line import/no-extraneous-dependencies
import { getFunctions } from 'firebase/functions';
import { fetchAndActivate, getRemoteConfig, getValue } from 'firebase/remote-config';
// eslint-disable-next-line import/no-extraneous-dependencies
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const firebaseApp = initializeApp(firebaseConfig);
const remoteConfig = getRemoteConfig(firebaseApp);

remoteConfig.settings = {
  // Ile czekamy na odpowiedź backendu. Poprzednie `0` NIE znaczyło „bez limitu" —
  // to był timeout natychmiastowy, więc każdy fetch przerywał się, zanim zdążył wyjść.
  fetchTimeoutMillis: 10_000,
  // Jak długo trzymamy pobrane wartości, zanim odpytamy ponownie. Firebase zaleca 12 h
  // na produkcji i ostrzega, że niski interwał przy wielu klientach wchodzi w limity
  // usługi (błąd FETCH_THROTTLE). Poprzednie `0` znaczyło: odpytuj przy KAŻDYM starcie
  // aplikacji, dla każdego użytkownika. Na serwerze deweloperskim zostawiamy 0, żeby
  // zmiana w konsoli Firebase była widoczna od razu — `import.meta.env.DEV` jest true
  // tylko przy `vite` (dev server), a nie przy `vite build --mode development`.
  minimumFetchIntervalMillis: import.meta.env.DEV ? 0 : 12 * 60 * 60 * 1000,
};

/**
 * Wartości obowiązujące, ZANIM (albo gdy nigdy nie) przyjdzie odpowiedź z backendu.
 *
 * Bez tego `getValue` zwraca puste dane ze źródłem `static` i każda flaga czytana przed
 * pierwszym `fetchAndActivate` jest fałszywie wyłączona — co wygląda identycznie jak
 * celowe wyłączenie i nie da się tego odróżnić w debugu.
 *
 * KAŻDA nowa flaga musi tu trafić z BEZPIECZNĄ wartością domyślną. Bezpieczna znaczy
 * „funkcja niewidoczna": gdy Remote Config nie odpowie, użytkownik ma zobaczyć mniej,
 * nie więcej.
 */
remoteConfig.defaultConfig = {
  stripe_enable: false,
};

export const auth = getAuth(firebaseApp);

// UWAGA: nie ustawiamy tu setPersistence(). To wywołanie odpalało się przy każdym
// załadowaniu modułu i migrowało zalogowanego użytkownika do localStorage, kasując
// wybór "Zapamiętaj mnie" przy pierwszym przeładowaniu strony.
// Trwałość ustawia userState przed samym signIn: zaznaczone -> browserLocalPersistence,
// odznaczone -> browserSessionPersistence. Domyślna trwałość getAuth() to i tak 'local'.
// Trwały cache w IndexedDB, wspólny dla kart. Domyślny cache w pamięci znika z każdym
// przeładowaniem strony, więc każdy listener czytał od zera wszystkie dokumenty swojego
// zapytania. Z trwałym cache Firestore po ponownym podłączeniu (do 30 min) dociąga tylko
// zmiany, a przy wielu otwartych kartach jedna karta trzyma połączenie w imieniu pozostałych.
// Tryb live (onSnapshot) działa bez zmian: pierwszy snapshot przychodzi z cache, potem serwer.
export const db = initializeFirestore(firebaseApp, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});
export const storage = getStorage(firebaseApp);
export const functions = getFunctions(firebaseApp, 'europe-west1');
export { fetchAndActivate, getValue, remoteConfig };
